/**
 * Utilidad para formatear menciones, hashtags y URLs en posts
 */

const getLinkLabel = (url) => {
  try {
    const { hostname, pathname } = new URL(url);
    const host = hostname.toLowerCase().replace(/^www\./, '');

    if (host.includes('sharepoint.com')) return 'SharePoint';
    if (host.includes('teams.microsoft.com') || host.includes('teams.live.com')) return 'Teams';
    if (host.includes('youtube.com') || host.includes('youtu.be')) return 'YouTube';
    if (host.includes('drive.google.com')) return 'Google Drive';
    if (host.includes('docs.google.com')) return 'Google Docs';
    if (host.includes('forms.google.com') || host.includes('forms.gle')) return 'Google Forms';
    if (host.includes('github.com')) return 'GitHub';
    if (host.includes('linkedin.com')) return 'LinkedIn';
    if (host.includes('onedrive.live.com') || host.includes('1drv.ms')) return 'OneDrive';
    if (host.includes('powerbi.com')) return 'Power BI';
    if (host.includes('office.com')) return 'Office 365';
    if (host.includes('zoom.us')) return 'Zoom';
    if (host.includes('meet.google.com')) return 'Google Meet';

    // Extraer nombre legible del path si el host es muy genérico
    const pathParts = pathname.split('/').filter(Boolean);
    if (host.length <= 30) return host;
    return host.substring(0, 27) + '...';
  } catch {
    if (url.length > 40) return url.substring(0, 37) + '...';
    return url;
  }
};

export const formatMentions = (text) => {
  if (!text) return "";

  const parts = [];
  // Regex que captura URLs (https/http), menciones y hashtags
  const tokenRegex = /(https?:\/\/[^\s<>"[\]()]+|@[a-zA-ZÀ-ÿ0-9._-]+(?:\s+[a-zA-ZÀ-ÿ0-9._-]+)?|#[a-zA-ZÀ-ÿÀ-ſ0-9_-]+)/g;
  let lastIndex = 0;
  let match;

  while ((match = tokenRegex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push({
        type: 'text',
        content: text.substring(lastIndex, match.index)
      });
    }

    const token = match[0];

    if (/^https?:\/\//i.test(token)) {
      parts.push({
        type: 'url',
        content: token,
        label: getLinkLabel(token)
      });
    } else if (token.startsWith('@')) {
      parts.push({
        type: 'mention',
        content: token,
        username: token.slice(1)
      });
    } else {
      parts.push({
        type: 'hashtag',
        content: token,
        hashtag: token.slice(1)
      });
    }

    lastIndex = match.index + token.length;
  }

  if (lastIndex < text.length) {
    parts.push({
      type: 'text',
      content: text.substring(lastIndex)
    });
  }

  return parts;
};

export const renderFormattedText = (text, options = {}) => {
  const { onMentionClick, onHashtagClick } = options;
  const parts = formatMentions(text);

  return parts.map((part, index) => {
    if (part.type === 'url') {
      return (
        <a
          key={index}
          href={part.content}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: '#0077c8',
            fontWeight: '600',
            textDecoration: 'underline',
            wordBreak: 'break-all'
          }}
          title={part.content}
        >
          {part.label}
        </a>
      );
    }

    if (part.type === 'mention') {
      return (
        <span
          key={index}
          style={{
            color: '#0077c8',
            fontWeight: '600',
            cursor: 'pointer',
            textDecoration: 'underline'
          }}
          title={`Mencionar a ${part.username}`}
          onClick={() => onMentionClick?.(part.username)}
        >
          {part.content}
        </span>
      );
    }

    if (part.type === 'hashtag') {
      return (
        <span
          key={index}
          style={{
            color: '#0077c8',
            fontWeight: '700',
            cursor: 'pointer'
          }}
          title={`Filtrar por #${part.hashtag}`}
          onClick={() => onHashtagClick?.(part.hashtag)}
        >
          {part.content}
        </span>
      );
    }

    return <span key={index}>{part.content}</span>;
  });
};

const mentionFormatter = {
  formatMentions,
  renderFormattedText
};

export default mentionFormatter;
